import {
  GET_COTATION,
  GET_COTATIONS,
  GET_MANUFACTURER,
  GET_MODEL,
  COTATION_ERROR,
  UPDATE_COTATION,
  CLEAR_COTATION
} from '../actions/types';

const initialState = {
  cotation: null,
  cotations: [],
  distinctManufacturer: [],
  distinctModel: [],
  loading: true,
  error: {}
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_COTATION:
    case UPDATE_COTATION:
      return {
        ...state,
        cotation: payload,
        loading: false
      };
    case GET_COTATIONS:
      return {
        ...state,
        cotations: payload,
        loading: false
      };
    case GET_MANUFACTURER:
      return {
        ...state,
        distinctManufacturer: payload,
        loading: false
      };
    case GET_MODEL:
      return {
        ...state,
        distinctModel: payload,
        loading: false
      };
    case COTATION_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
        cotation: null,
        cotations: [],
        distinctManufacturer: [],
        distinctModel: []
      };
    case CLEAR_COTATION:
      return {
        ...state,
        cotation: null,
        cotations: [],
        distinctManufacturer: [],
        distinctModel: [],
        loading: true
      };
    default:
      return state;
  }
}
